import React, { useContext } from 'react';
import svg from '../../svg';
import { AppContext } from '../context/Provider';

const HeaderImage = ({
  ap_url,
  url,
  usePlaceholder = false,
  statusInfo = null,
  type,
  availableInfo,
  textInfo = null,
  isImmediatelyAvailable = false,
  address,
}) => {
  const appContext = useContext(AppContext);

  if (!url && !usePlaceholder) {
    return false;
  }

  let imageUrl = '';

  if (usePlaceholder) {
    imageUrl = '/app/themes/asuntosaatio/public/images/aso-placeholder.png';
  } else {
    const cloudFlareBase = appContext?.cloudFlareBaseUrl;
    let imagePath = false;

    try {
      imagePath = new URL(url).pathname;
    } catch (e) {
      // Invalid Url
    }

    const cloudFlareBaseParsed = cloudFlareBase
      ? cloudFlareBase.endsWith('/')
        ? cloudFlareBase.slice(0, -1)
        : cloudFlareBase
      : null;
    imageUrl =
      cloudFlareBaseParsed && imagePath
        ? cloudFlareBaseParsed +
          '/cdn-cgi/image/width=840,quality=90' +
          imagePath
        : url;
  }

  let style = {
    height: '412px',
  };

  return (
    <header className='relative w-full bg-cover bg-no-repeat' style={style}>
      <div
        className={`${
          type === 'aso' ? 'top-left-triangle-pink' : 'top-left-triangle-blue'
        }`}
      >
        <span className='text-tiny text-black'>
          {'aso' === type ? 'asokoti' : 'vuokra'}
        </span>
      </div>
      <figure>
        <a href={ap_url}>
          <img
            src={imageUrl}
            className='object-cover absolute top-0 left-0 w-full h-full'
            alt={address}
            loading='lazy'
          />
        </a>
      </figure>
      <div className='absolute bottom-0 left-0 right-0'>
        {availableInfo && (
          <div className='bg-green-700 text-tiny text-white font-bold w-full flex items-center py-2 px-12'>
            {isImmediatelyAvailable && (
              <span
                className='inline-block mr-4 w-9'
                dangerouslySetInnerHTML={{
                  __html: svg('exclamation-mark-green'),
                }}
              ></span>
            )}
            <span className='inline-block leading-none'>{availableInfo}</span>
          </div>
        )}
        {statusInfo && (
          <div className='bg-green-700 text-tiny text-white font-bold w-full'>
            <span className='py-2 px-12 block leading-none'>
              {statusInfo}
            </span>
          </div>
        )}
        {textInfo && (
          <div className='bg-green-400 text-tiny text-white font-bold w-full'>
            <span className='py-2 px-12 block leading-none'>{textInfo}</span>
          </div>
        )}
      </div>
    </header>
  );
};

export default HeaderImage;
